import { render, staticRenderFns } from "./ChangePasswordUserController.html?vue&type=template&id=58ac85f7&scoped=true&external"
import script from "./ChangePasswordUserController.vue?vue&type=script&lang=js"
export * from "./ChangePasswordUserController.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordUserController.scss?vue&type=style&index=0&id=58ac85f7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac85f7",
  null
  
)

export default component.exports